<template>
  <div class="trial-bar">
    <div class="d-flex align-items-center">
      <span class="btn btn-dark trial-bar__btn">TRIAL</span>
      <span v-if="trialDaysLeft >= 0" class="trial-bar__remainder">{{ $tc('subscription.days_left', trialDaysLeft, { value: trialDaysLeft }) }}</span>
    </div>
    <span class="trial-bar__description">{{ description }}</span>
    <button class="btn btn-light trial-bar__btn trial-bar__btn--plan" @click="openPaymentModal">
      {{ callToAction }}
    </button>
  </div>
</template>
<script setup>
  import { computed } from 'vue';
  import { langService } from '@/core';
  import { useSubscriptionStore } from '@/stores/subscription';
  import { useAuthStore } from '@/stores/auth.ts';

  const subscriptionStore = useSubscriptionStore();
  const authStore = useAuthStore();

  const trialDaysLeft = computed(() => authStore.user?.permissions?.user_subscription?.days_left);

  const description = computed(() => {
    if (trialDaysLeft.value < 0) {
      return langService.trans('subscription.trial_description_four');
    }

    if (trialDaysLeft.value === 0) {
      return langService.trans('subscription.trial_description_three');
    }

    if (trialDaysLeft.value <= 7) {
      return langService.trans('subscription.trial_description_two', { days: trialDaysLeft.value });
    }

    return langService.trans('subscription.trial_description_one');
  });

  const callToAction = computed(() => {
    if (trialDaysLeft.value < 0) {
      return langService.trans('subscription.actions.unlock_features');
    }

    if (trialDaysLeft.value === 0) {
      return langService.trans('subscription.actions.select_plan');
    }

    if (trialDaysLeft.value <= 7) {
      return langService.trans('subscription.actions.activate_plan');
    }

    return langService.trans('subscription.actions.explore_pricing');
  });

  function openPaymentModal() {
    subscriptionStore.setModalVisible(true);
  }
</script>
